import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ConflictInterestPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    CONFLICT OF INTEREST POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Maintaining Integrity and Transparency
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Akindele Bakarey</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V14 - 2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>01/08/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>01/08/2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}><strong>ALL EMPLOYEES and FREELANCE STAFF</strong></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Record of Changes:</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Purpose */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Purpose
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The purpose of this policy is to provide guidance to relevant individuals on handling possible conflicts of interest that may arise at DTK College as a training and Education provider, assessor and moderator of accredited units and qualifications.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This policy applies to all staff and other individuals whenever they interact or potentially interact with any of the college's operations.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px' }}>
                    This policy:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px', paddingLeft: '20px' }}>
                    ·Defines what is meant by conflict of interest sets out the roles and responsibilities for managing conflict of interest
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    ·Illustrations of potential conflict of interest situations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Scope */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Scope
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    It is the policy of DTK College that Tutors, Assessors and Internal Quality Assurers acting on behalf of the college must be free from conflicts of interest that could adversely affect their judgment or objectivity to the organisation in conducting business activities and assignments.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Accordingly, these persons are required at the outset to disclose any legitimate financial, business, charitable and other activities outside of their recognised roles at the college, but any potential conflict of interest raised by those activities must be acknowledged, disclosed, and in relevant cases properly managed.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    It is the responsibility of each individual to recognise situations in which they have a conflict of interest, or might reasonably be seen by others to have a conflict; to disclose this conflict and to take such further steps as may be appropriate and set out in more detail under the procedure below.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Definition of conflict of interest */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Definition of conflict of interest
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    A conflict of interest is a situation in which an individual, or organisation, has competing interests or loyalties. Conflicts of interest can arise in a variety of circumstances in relation to awarding organisation activity, for example:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    ·where the training delivery function and the awarding function rest within one organisation and the functions are not strictly delineated
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    ·when an individual has a position of authority in one organisation which conflicts with his or her interests in another organisation
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    ·when an individual has personal interests that conflict with his/her professional position
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    ·A conflict of interest may generally be defined as a conflict between the official responsibilities of a tutor, assessor, and internal verifier and any other interests the individual may have and as such could compromise or appear to compromise their decisions
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    ·A person who is connected to the development, delivery, or award of qualifications by the organisation has interests in any other activity which have the potential to lead that person to act contrary to his or her interests in that development, delivery or award in accordance with the awarding organisations conditions of recognition
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    · An informed and reasonable observer would conclude that either of the above situations was the case
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    ·Tutors and assessors working with a business that is in direct competition to the College
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    ·Tutors and assessors participating in the appointment, supervision evaluation or
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    ·assessment of a person with whom the person, has close or familial ties
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    ·Tutors and assessors having a close or familial relationship with the registered learner, or learners' family whilst being involved in decisions about the outcome of their accreditation or qualification or where the person whose remuneration is in part determined by the outcome of the assessment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Roles and responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Roles and responsibilities
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    All relevant staff undertaking assessment ('assessors'), moderation ('moderators' or 'quality assurers') and other individuals have a responsibility to be aware of the potential for a conflict of interest.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Such situations must be carefully managed to ensure that any conflict of interest does not detrimentally impact on the standards of the college and its awarding and inspecting bodies as well as public confidence.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Page 3 - Continued Responsibilities and Scope */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    It is the duty of all tutors and assessors to disclose any actual or potential conflict or interest, to their line managers or the Director, in writing. The information submitted is then evaluated to identify if any further action is required and a written record of the outcome of the evaluation is kept and a copy will be provided to the concerned individuals.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    If the individual concerned has any changes to their declared circumstances, they must inform their line manager immediately in writing, so that the conflict of interest can be evaluated, and the register updated.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Scope
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    A Conflict of Interest is deemed to exist where:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    a) The interests of DTK College in any activity undertaken by it, on its behalf or by a member of its staff have the potential to lead it to act contrary to its interests of the development, delivery, and award of qualifications in accordance with its conditions of registration by the awarding body.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    b) A person who is connected to the development, delivery, or award of qualifications by the awarding organisation has interests in any other activity which have the potential to lead that person to act contrary to his or her interests in that development, delivery or award in accordance with the awarding organisation's Conditions of Recognition.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    c) An informed and reasonable observer would conclude that either of these situations was the case.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Managing and Declaring Conflicts of Interest */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Managing and Declaring Conflicts of Interest
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    It is the responsibility of all DTK staff to declare all conflict of interest. Any undeclared conflict of interest and instances where assessment has taken place where conflict of interest exists may be investigated in line with awarding body policies.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    All conflict of interest pertaining to the assessment of Vocational Qualifications will be declared to the awarding body.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Everyone involved in the assessment process is responsible for declaring any conflict of interest. Where DTK College can mitigate against a declared conflict of interest, the mitigation will be included in the declaration. In instances where DTK College cannot mitigate against a conflict of interest (for example, where the only qualified assessor and internal quality assurer available at a college are related) the unresolved conflict will be declared to the awarding body to enable it to plan to mitigate through the external quality assurance process.
                  </p>

                  <div style={{ 
                    marginTop: '30px',
                    padding: '25px',
                    backgroundColor: '#F5EBFA',
                    borderLeft: '4px solid #7B3F9E',
                    borderRadius: '8px'
                  }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', fontWeight: '500' }}>
                      College Quality Nominees will be directly responsible for ensuring the submission of declarations of conflict of interest to the awarding body.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default ConflictInterestPolicy;